var $ = require('jquery');
var _ = require('underscore');
var Marionette = require('marionette');
var Entities = require('Entities');
var Configuration = EY.Consultation.Lookups.Configuration;
var CustomFieldType = EY.Consultation.Lookups.CustomFieldType;
var FilterType = EY.Consultation.Lookups.FilterType;
var Labels = EY.Consultation.Labels;
var Resources = EY.Consultation.Resources;

var build = function (keyword, attachments) {
    var criteria = { $regex: keyword, $options: 'i' };
    var pattern = new RegExp(keyword, 'i');
    var accountingStandardCriteria = _.chain(EY.Consultation.Lookups.PrimaryAccountingStandardType).filter(function (item) {
        return pattern.test(Labels[item]);
    }).value().join('|');
    var geographyCriteria = _.chain(Resources.Geography).filter(function (geography) {
        return pattern.test(geography.text);
    }).pluck('id').value().join('|');
    var industryCriteria = _.chain(Resources.Industry).filter(function (industry) {
        return pattern.test(industry.name);
    }).pluck('id').value();
    var recordTypeCriteria = _.chain(EY.Consultation.Resources.Enumeration).where({ type: 'RecordType' }).filter(function (item) {
        return pattern.test(Labels[item.id]);
    }).pluck('id').value().join('|');


    return {
        $or: [
            { 'approvers.comments': criteria },
            { 'approvers.givenName': criteria },
            { 'assignedToGivenName': criteria },
            { 'attachments.comments': criteria },
            { 'attachments.filename': criteria },
            { 'attachments.id': { $in: attachments.length > 0 ? attachments : [-1] } },
            { 'accountingStandard': { $regex: accountingStandardCriteria ? accountingStandardCriteria : "-1" } },
            { 'clientId': criteria },
            { 'clientName': criteria },
            { 'communication': criteria },
            { 'creatorGivenName': criteria },
            { 'description': criteria },
            { 'engagementId': criteria },
            { 'engagementName': criteria },
            { 'fields': { $elemMatch: { customFieldTypeId: CustomFieldType.Text, answer: criteria } } },
            { 'fields': { $elemMatch: { customFieldTypeId: CustomFieldType.Dropdown, answer: { $elemMatch: { selected: true, text: criteria } } } } },
            { 'geographyId': { $regex: geographyCriteria ? geographyCriteria : "-1" } },
            { 'id': criteria },
            { 'industryId': { $in: industryCriteria } },
            { 'recordTypeId': { $regex: recordTypeCriteria ? recordTypeCriteria : "-1" } },
            { 'subjectDescription': criteria },
            { 'subject': criteria },
            { 'subtype': criteria },
            { 'type': criteria }
        ]
    };
};

var searchDocuments = function (keyword) {
    return new Entities.SolrSearch({ id: keyword }).fetch();
};

var View = Marionette.View.extend({
    events: {
        'click @ui.search': 'search',
        'keypress input[type=text]': 'enter'
    },
    template: '#searchLayout',
    ui: {
        keyword: '#keyword',
        search: '#search'
    },
    initialize: function () {
        var context = this;
        var queries = this.options.queries;

        queries.on('change:saved-search', function (query) {
            context.ui.keyword.val(query.get('keyword'));
            context.search({ aggregate: query.get('saved-search') });
            query.set({ 'saved-search': {} }, { silent: true });
        });
    },
    enter: function (e) {
        if (e.keyCode === 13) {
            this.search();
        }
    },
    search: function (options) {
        options = options || {};
        var consultation = require('Consultation');
        var aggregate = options.aggregate;
        var keyword = this.ui.keyword.val().trim().replace(/([&()!}[~"/{*+:.$^\\|?\]])/g, '\\$1');
        var queries = this.options.queries;

        if (keyword) {
            $("#homegrid table tbody").html("<tr><td><span class ='loading-progress'>"+ Labels.LoadingMessage +"</span></td></tr>");
            var charLength = keyword.replace(/\\/g, "").length > Number(Configuration.LimitSearchChar);
            _.each(Configuration.RestrictSearchSpecialChar.split(','), function (char) {
                if (keyword.indexOf(char) !== -1) {
                    var charArray = keyword.split(char);
                    keyword = charArray[0].replace(/\\/g, "") ? charArray[0].replace(/\\/g, "") : charArray[1].replace(/\\/g, "");
                }
            });
            if (!charLength) {
                var geographyFilter = this.options.geography;
                var filter = this.options.filter;

                searchDocuments(keyword.replace(/\\\//g, '')).done(function (results) {
                    var attachments = _.pluck(results, 'id');
                    //Configuration.matchedAttachmentIds = attachments;
                    sessionStorage.setItem('matchedAttachmentIds', attachments);
                    var criteria = build(keyword, attachments);

                    queries.any(function (model) { return model.get('selected') && model.set('selected', false); });
                    if (aggregate) {
                        aggregate.push({ $match: { $and: [criteria, { $or: [geographyFilter, filter] }] } });
                        queries.get('').set({ selected: false }).set({ aggregate: aggregate, selected: true });
                    } else {
                        queries.findWhere({ type: FilterType.Search }).set({ selected: true, filter: { $and: [criteria, { $or: [geographyFilter, filter] }] }, keyword: keyword });
                    }
                });
            } else {
                var text = Labels.LimitSearchCharMsg;
                consultation.showToast({
                    result: "danger",
                    text: text
                });
            }
        }
    }
});

module.exports.show = function (options) {
    var region = options.region;

    region.show(new View(options));
};


// WEBPACK FOOTER //
// ./js/Modules/Home/HomeSearch.js